import { SubjectData } from 'shell/models/person';
import { ForeignVM } from 'subscription/view-models/common-interface-subscription';

export const transformAddressForeign = (person: SubjectData): ForeignVM | undefined => {
  const localitaEstera = (person?.residenza || [])[0]?.localitaEstera;
  if (!localitaEstera) {
    return undefined;
  }

  const valueConsulate = person.descrizioneConsolatoResidenza
    ? person.descrizioneConsolatoResidenza
    : '';

  return {
    address: localitaEstera?.indirizzoEstero?.toponimo?.denominazione || '',
    civicNumber: localitaEstera.indirizzoEstero?.toponimo?.numeroCivico || '',
    cap: localitaEstera.indirizzoEstero?.cap || '',
    consulateCode: localitaEstera.consolato?.codiceConsolato
      ? {
          id: localitaEstera.consolato.codiceConsolato || '',
          value: valueConsulate || localitaEstera.consolato.descrizioneConsolato || '',
        }
      : undefined,
    foreignState: localitaEstera.indirizzoEstero?.localita
      ? {
          id: localitaEstera.indirizzoEstero.localita.codiceStato || '',
          value: localitaEstera.indirizzoEstero.localita.descrizioneStato || '',
          province: localitaEstera.indirizzoEstero.localita.provinciaContea || '',
        }
      : undefined,
    municipality: localitaEstera.indirizzoEstero?.localita?.descrizioneLocalita
      ? {
          description: localitaEstera.indirizzoEstero.localita.descrizioneLocalita || '',
          province: localitaEstera.indirizzoEstero.localita.provinciaContea || '',
        }
      : undefined,
  };
};
